export const addEvent = (() => {
  if (typeof window !== `undefined`) {
    if (document.addEventListener) {
      return function(el, type, fn) {
        if ((el && el.nodeName) || el === window) {
          el.addEventListener(type, fn, false);
        } else if (el && el.length) {
          for (var i = 0; i < el.length; i++) {
            addEvent(el[i], type, fn);
          }
        }
      };
    } else {
      return function(el, type, fn) {
        if ((el && el.nodeName) || el === window) {
          el.attachEvent('on' + type, function() {
            return fn.call(el, window.event);
          });
        } else if (el && el.length) {
          for (var i = 0; i < el.length; i++) {
            addEvent(el[i], type, fn);
          }
        }
      };
    }
  }
})();

export const asTime = t => {
  t = Math.round(t);
  var s = t % 60;
  var m = Math.round(t / 60);

  return two(m) + ':' + two(s);
};

export const two = s => {
  s += '';
  if (s.length < 2) s = '0' + s;
  return s;
};

export const prefetch_file = (
  url,
  fetched_callback,
  progress_callback,
  error_callback
) => {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';

  xhr.addEventListener(
    'load',
    function() {
      if (xhr.status === 200) {
        var URL = window.URL || window.webkitURL;
        var blob_url = URL.createObjectURL(xhr.response);
        fetched_callback(blob_url);
      } else {
        error_callback();
      }
    },
    false
  );

  var prev_pc = 0;
  xhr.addEventListener('progress', function(event) {
    if (event.lengthComputable) {
      var pc = Math.round((event.loaded / event.total) * 100);
      if (pc != prev_pc) {
        prev_pc = pc;
        progress_callback(pc);
      }
    }
  });
  xhr.send();
};



// WEBPACK FOOTER //
// ./src/utils/helper-functions/video-sync.js